import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { AppHttpInterceptor } from './AppHttpInterceptor';
import { ApiService } from './services/api.service';
import { ValueService } from './services/value.service';
import { NotifyService } from './services/notify.service';
import { IonicModule } from '@ionic/angular';
import { HomeModule } from './home/home.module';
import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BsDatepickerConfig, BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap';
import { UnsubscribePageComponent } from './unsubscribe-page/unsubscribe-page.component';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
// import { NgxSpinnerModule } from 'ngx-spinner';
@NgModule({
  declarations: [
    AppComponent,
    UnsubscribePageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,   
    LayoutModule,
    HomeModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    MaterialModule,
    MatDatepickerModule,  
    NgxMaterialTimepickerModule,
    IonicModule.forRoot(),
    GalleryModule,
    LightboxModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    CKEditorModule,
    PdfViewerModule,
    DatepickerModule,
    RouterModule,
    MatInputModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    NgxSpinnerModule,
    MatExpansionModule,
    BsDatepickerModule.forRoot(),
     
    
  ],
  providers: [
    ApiService,
    ValueService,
    NotifyService,
    HttpClient,
    CookieService,
    AppComponent,
    BsDatepickerConfig,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
